import { render, staticRenderFns } from "./StrongTitle.vue?vue&type=template&id=2bba8654&scoped=true"
import script from "./StrongTitle.vue?vue&type=script&lang=js"
export * from "./StrongTitle.vue?vue&type=script&lang=js"
import style0 from "./StrongTitle.vue?vue&type=style&index=0&id=2bba8654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba8654",
  null
  
)

export default component.exports